import { rulerThickness, canvasSize, canvasPanelTop } from 'Constants/viewportLayout';

export const easelPositionFromScreenCoordinates = (point, easelOffset, easelScale) => {
  return {
    x: ((canvasSize / 2) - easelOffset[0]) + ((point.x - rulerThickness) / easelScale),
    y: ((canvasSize / 2) - easelOffset[1]) +
    ((point.y - (rulerThickness + canvasPanelTop)) / easelScale),
  };
};

export const easelSizeInEaselCoordinates = (easelSize, easelScale) => ({
  width: ((easelSize.width - rulerThickness) / easelScale),
  height: (easelSize.height / easelScale),
});

export const easelSizeWithoutRulers = easelSize => ({
  width: easelSize.width - rulerThickness,
  height: easelSize.height - rulerThickness,
});



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/utils/index.js